<div class="panel-expand-content">
  <div class="checkbox-extra-sm">
    <label
      class="checkbox-line"
      nz-checkbox
      (ngModelChange)="handleCheckChange($event)"
      [ngModel]="tempModel.selected === 'implied'"
    >
      Include inferred data
    </label>
  </div>

  <p><strong>Cell Color Code</strong></p>

  <div class="inferred-legend">
    <p>Inferred Data</p>
    <p>Calculated with Inferred Data</p>
    <p>Inferred Quarterlies</p>
    <p>Inferred Annual Projections</p>
  </div>

  <div class="actions">
    <button
      [disabled]="actionsDisabled"
      nz-button
      nzType="default"
      nzSize="small"
      (click)="handleCancel()"
    >
      Cancel
    </button>
    <button
      id="options-refresh-buttons-apply-Adjustments"
      [disabled]="actionsDisabled"
      nz-button
      nzType="primary"
      nzSize="small"
      (click)="handleApply($event)"
    >
      Apply
    </button>
  </div>
</div>
